import styled from "styled-components";

export const StyledCurrencyWrapper = styled.div`
  .currency-head {
    padding: 20px 0;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;
    
    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }
  }
`;